/* a-filter — 単一選択ラジオ変更で即フォーム送信（GET絞り込み）
   静的元: SecretEC_shopify-markup/assets/js/a-filter.js
   セクション複数配置に耐えるよう querySelectorAll で各フォームを初期化。 */
(function () {
  "use strict";

  const init = () => {
    const forms = document.querySelectorAll(".a-filter__form");

    forms.forEach((form) => {
      form.addEventListener("change", (event) => {
        if (event.target.matches(".a-filter__input")) {
          form.submit();
        }
      });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
